import { css } from 'aphrodite';
import {ComposedChart,
         Cell,
         Bar,
         Line,
         XAxis,
         YAxis,
         Tooltip,
         ResponsiveContainer,
         Legend} from 'recharts';
import {HorizontalAxisTick, VerticalAxisTick} from './AxisTick'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faFileImage, faToggleOff, faToggleOn} from '@fortawesome/free-solid-svg-icons'
import fileDownload from 'js-file-download'
import {json2csv} from 'json-2-csv'
import * as React from 'react';
import { StackedTrendItem } from 'src/models/StackedTrendItem.js';
import domtoimage from 'dom-to-image';
import {styles} from "src/styles/TrendChart";
import { Button, Card, CardBody } from 'reactstrap';
import CardHeader from 'reactstrap/lib/CardHeader';
import { RequestState } from 'src/models/RequestState';
import { StackedChartTooltip } from './StackedChartTooltip';
import { YearPicker } from '../YearPicker';

interface ITrendChartProps {
    title: string
    data: StackedTrendItem[],
    state?: RequestState,
    error?: string,
    onTrendBarClick: any,
    onTrendSelectionCleared?: any,
    value1Label?: string,
    value2Label?: string,
    value3Label?: string,
    value4Label?: string,
    labelName?: string,
    valueFormatter?: any,
    verticalTickFormatter?: any,
    showToggle?: boolean,
    isToggleOn: boolean,
    toggleLabel?: string,
    toggleLabel2?: string,
    onToggleStateChanged?: any,
    initStartYear: number,
    initEndYear: number,
    onRangeChanged?: (startYear: number, endYear: number)=>void;
}

class TrendChartState {
    public readonly isTrendBarSected: boolean;
    public readonly selectedTrendBarIndex: number;
    public readonly startYear: number;
    public readonly endYear: number;
    public readonly isStartYearDialogVisible: boolean = false;
    public readonly isEndYearDialogVisible: boolean = false;
    constructor(){
        this.isTrendBarSected = false;
        this.selectedTrendBarIndex = 0;
        const date = new Date();
        this.startYear = date.getFullYear() - 5;
        this.endYear = date.getFullYear();
    }   
}

const value1Fill = "#ed7250";
const value2Fill = "#e5cf60";
const value3Fill = "#a608bf";
const value4Fill = "#0967bf";

const disabledFill = "#adafb2"

export class StackedTrendChart extends React.Component<ITrendChartProps,TrendChartState> {

    constructor(props: ITrendChartProps){
        super(props)
        let newState = new TrendChartState();
        // set the initial state form props
        newState = {...newState, startYear: this.props.initStartYear, endYear: this.props.initEndYear}; 
        this.state = newState;
    }

    public static defaultProps = {
        state: RequestState.SUCCESS,
        error: "",
        valueLabel: "value",
        labelName: "Year",
        showToggle: false,
        toggleLabel: ""
    };

    public render(){

        let selectionView;

        if(this.state.isTrendBarSected){
            selectionView = (
                <div id="custom_views" className={css(styles.selectionView)} >
                    <div>
                        Selected Year : FY {this.props.data[this.state.selectedTrendBarIndex].year}
                    </div>
                    <Button color="link" onClick={this.onClearClick} >
                        Clear
                    </Button>  
                </div>
            )
        }else{
            selectionView = (
                <div id="custom_views" className={css(styles.selectionView)} >
                        
                </div>
            )
        }

        let togglView;
        
        if(this.props.showToggle){
            let toggleIcon;
            let toggleIconStyle;
            if(this.props.isToggleOn){
                toggleIcon = faToggleOn;
                toggleIconStyle = styles.toggleIconOn;
            }else{
                toggleIcon = faToggleOff;
                toggleIconStyle = styles.toggleIconOff;
            }
            togglView = (
                <div id="toggle_view" className={css(styles.toggleViewContainer)} >

                    <div id="label" className={css(styles.toggleLabel)} >
                        {this.props.toggleLabel}
                    </div>

                    <div onClick={this.onToggleClick} className={css(toggleIconStyle)} >
                        <FontAwesomeIcon icon={toggleIcon} />
                    </div>

                    <div id="label" className={css(styles.toggleLabel)} >
                        {this.props.toggleLabel2}
                    </div>
                </div>
            )
        }else{
            togglView = (
                <div>

                </div>
            )
        }

        const data = this.props.data;

        let content;
        if(this.props.state === RequestState.SUCCESS){
            content = (
                <ResponsiveContainer  height='80%' width='100%' >
                        <ComposedChart data={data}
                                margin={{top: 5, right: 30, left: 20, bottom: 5}}
                                >
                            <XAxis dataKey="year" tick={<HorizontalAxisTick fontSize={12} tickFormatter={this.horizontalTickFormatter} textAnchor={"middle"}/>} />
                            <YAxis tickFormatter={this.props.verticalTickFormatter} tick={{fontSize: 11}} /> } />
                            <Tooltip content={<StackedChartTooltip 
                                                    labelName={this.props.labelName}
                                                    value1Label = {this.props.value1Label}
                                                    value2Label = {this.props.value2Label}
                                                    value3Label = {this.props.value3Label}
                                                    value4Label = {this.props.value4Label}
                                                    valueFormatter = {this.props.valueFormatter}
                                                    />}/>
                            <Legend />
                            <Bar name={this.props.value1Label} dataKey="amount1" barSize={35} className={css(styles.trend_bar_hover)} onClick={this.onTrendBarClick} fill = {value1Fill} >
                                {
                                    data.map(this.buildTrendBar1)
                                }
                            </Bar>
                            <Bar name={this.props.value2Label} dataKey="amount2" barSize={35} className={css(styles.trend_bar_hover)} onClick={this.onTrendBarClick} fill = {value2Fill} >
                                {
                                    data.map(this.buildTrendBar2)
                                }
                            </Bar>
                            <Bar name={this.props.value3Label} dataKey="amount3" barSize={35} className={css(styles.trend_bar_hover)} onClick={this.onTrendBarClick} fill = {value3Fill} >
                                {
                                    data.map(this.buildTrendBar3)
                                }
                            </Bar>
                            <Bar name={this.props.value4Label} dataKey="amount4" barSize={35} className={css(styles.trend_bar_hover)} onClick={this.onTrendBarClick} fill = {value4Fill} >
                                {
                                    data.map(this.buildTrendBar4)
                                }
                            </Bar>
                        </ComposedChart>
                    </ResponsiveContainer>  
            );
        }else if(this.props.state === RequestState.LOADING){
            content = (<div className={css(styles.empty_view)} >
                            Loading
                        </div>);
        }else if(this.props.state === RequestState.ERROR){
            content = (<div className={css(styles.empty_view)} >
                            {this.props.error}
                        </div>);
        }else{
            content = (<div className={css(styles.empty_view)} >
                            Not requested
                        </div>);
        }

        let startYearDropDownContentStyle;
        if(this.state.isStartYearDialogVisible){
            startYearDropDownContentStyle = {
                display: "block"
            }
        }else{
            startYearDropDownContentStyle = {
                display: "none"
            }
        }

        let endYearDropDownContentStyle;
        if(this.state.isEndYearDialogVisible){
            endYearDropDownContentStyle = {
                display: "block"
            }
        }else{
            endYearDropDownContentStyle = {
                display: "none"
            }
        }

        return (
            <Card id="trend_container" className={css(styles.trend_container,styles.card)}>

                <CardHeader id="trend_header" className={css(styles.card_header)} >


                    <div id="trend_label" className={css(styles.card_label)} >
                        {this.props.title}
                    </div>

                    <div id="range" className={css(styles.range)} >
                        <div id="start_button_container" className={css(styles.dropdown)} onMouseLeave={this.onStartYearMouseLeave} >
                            <Button color="link" className={css(styles.date)} onClick={this.onStartYearClicked} >
                                FY {this.state.startYear}
                            </Button>
                            <div className={css(styles.dropdown_content)} style={startYearDropDownContentStyle}  >
                                <YearPicker 
                                        selectedStartYear={this.state.startYear} 
                                        selectedEndYear={this.state.endYear}
                                        onYearSelected={this.onStartYearSelected} 
                                        isStartYear={true}/>                                
                            </div>
                        </div>  
                        <div>
                            to
                        </div>
                        <div id="end_button_container" className={css(styles.dropdown)} onMouseLeave={this.onEndYearMouseLeave} >
                            <Button color="link" className={css(styles.date)} onClick={this.onEndYearClicked} >
                                FY {this.state.endYear}
                            </Button>
                            <div className={css(styles.dropdown_content)} style={endYearDropDownContentStyle}  >
                                <YearPicker 
                                        selectedStartYear={this.state.startYear}
                                        selectedEndYear={this.state.endYear}
                                        onYearSelected={this.onEndYearSelected}
                                        isStartYear={false} />                                
                            </div>
                        </div>  
                    </div>

                    {selectionView}
                    
                    {togglView}

                    <div id="icons" className={css(styles.icons)} >
                            <div onClick={this.onDownloadImageClick} className={css(styles.icon)} title={"Save as image"} >
                                <FontAwesomeIcon icon={faFileImage} />
                            </div>

                            <div onClick={this.onDownloadDataClick} className={css(styles.icon)} title={"Download data"} >
                                <FontAwesomeIcon icon={faDownload} />
                            </div>
                    </div>  

                </CardHeader>
                
                <CardBody id="div_trend_chart" className={css(styles.trend_chart_container)}>
                    {content}
                </CardBody>
        </Card>
        );
    }

    private onEndYearMouseLeave = (event: any) => {
        this.setState({...this.state, isEndYearDialogVisible: false})
    }

    private onEndYearClicked = (event: any) => {
        this.setState({...this.state, isEndYearDialogVisible: !this.state.isEndYearDialogVisible})
    }

    private onEndYearSelected = (year: number) => {
        if(year >= this.state.startYear && year - this.state.startYear <= 10){
            this.setState({...this.state, endYear: year, isEndYearDialogVisible: false})
            if(this.props.onRangeChanged){
                this.props.onRangeChanged(this.state.startYear, year);
            }
        }
    }

    private onStartYearMouseLeave = (event: any) => {
        this.setState({...this.state, isStartYearDialogVisible: false})
    }

    private onStartYearClicked = (event: any) => {
        this.setState({...this.state, isStartYearDialogVisible: !this.state.isStartYearDialogVisible})
    }

    private onStartYearSelected = (year: number) => {
        if(year <= this.state.endYear && this.state.endYear - year <= 10){
            this.setState({...this.state, startYear: year, isStartYearDialogVisible: false})
            if(this.props.onRangeChanged){
                this.props.onRangeChanged(year, this.state.endYear);
            }
        }
    }

    private onTrendBarClick = (entry: StackedTrendItem,index: number) => {
        this.setState({...this.state, isTrendBarSected: true, selectedTrendBarIndex: index})
        if(this.props.onTrendBarClick !== undefined){
            this.props.onTrendBarClick(entry,index);
        }
    }

    private onClearClick = (event: any) => {
        this.setState({...this.state, isTrendBarSected: false, selectedTrendBarIndex: -1})
        if(this.props.onTrendSelectionCleared !== undefined){
            this.props.onTrendSelectionCleared();
        }
    }

    private buildTrendBar1 = (_entry: StackedTrendItem,index: number) => {
        let fill = value1Fill;
        if(this.state.isTrendBarSected && this.state.selectedTrendBarIndex !== index){
            fill = disabledFill
        }
        return(
            <Cell cursor="pointer" fill={fill}  key={`cell-${index}`}/>
        );
    }
    
    private buildTrendBar2 = (_entry: StackedTrendItem,index: number) => {
        let fill = value2Fill;
        if(this.state.isTrendBarSected && this.state.selectedTrendBarIndex !== index){
            fill = disabledFill
        }
        return(
            <Cell cursor="pointer" fill={fill}  key={`cell-${index}`}/>
        );
    }

    private buildTrendBar3 = (_entry: StackedTrendItem,index: number) => {
        let fill = value3Fill;
        if(this.state.isTrendBarSected && this.state.selectedTrendBarIndex !== index){
            fill = disabledFill
        }
        return(
            <Cell cursor="pointer" fill={fill}  key={`cell-${index}`}/>
        );
    }

    private buildTrendBar4 = (_entry: StackedTrendItem,index: number) => {
        let fill = value4Fill;
        if(this.state.isTrendBarSected && this.state.selectedTrendBarIndex !== index){
            fill = disabledFill
        }
        return(
            <Cell cursor="pointer" fill={fill}  key={`cell-${index}`}/>
        );
    }


    private onDownloadImageClick = (event: any) => {
        const element = document.getElementById("trend_container");
        if(element !== null){
            domtoimage.toBlob(element)
            .then((blob: any) => {
                fileDownload(blob, `trend_chart.png`);
            });
        }
    }

    private onDownloadDataClick = (event: any) => {
        json2csv(this.props.data,(err: any,csv: any) => {
            fileDownload(csv,"data.csv")
        })
    }

    private onToggleClick = (event: any) => {
        if(this.props.onToggleStateChanged !== undefined){
            this.props.onToggleStateChanged(!this.props.isToggleOn);
        }
    }

    private horizontalTickFormatter = (value: string) => {
        return "FY-" + value;
    }

}



// WEBPACK FOOTER //
// ./src/components/charts/StackedTrendChart.tsx